// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3H5Il","modalForm":"UpgradeEpcsModal_modalForm__1-Oo5","modalFooter":"UpgradeEpcsModal_modalFooter__8PMlG"};